/* ============================================================
   pc-cart-feedback.js — Plant Club
   Loaded from layout/theme.liquid, only when the cart is a drawer.

   WHY THIS EXISTS

   The SellUp / LaunchTip upsell rail on the product page adds to
   the cart by POSTing straight to /cart/add.js. It never tells the
   theme. Dawn only opens the cart drawer and refreshes the count
   bubble when Dawn itself performed the add, so the result was a
   button that worked perfectly and looked completely dead:

       measured on the live theme, one click on a rail Add button
         POST /cart/add.js        -> 200
         cart item_count          -> 7 then 8
         console errors           -> none
         cart drawer visibility   -> hidden before AND after
         header count bubble      -> unchanged

   The item goes in. Nothing on screen moves. A shopper reads that
   as broken and does not click again, so the add that did succeed
   is the only one they will ever make.

   WHAT THIS DOES

   Watches fetch and XMLHttpRequest for a successful POST to
   /cart/add(.js). If the response carries a `sections` key, Dawn
   made that request itself and is already rendering the drawer, so
   we do nothing. If it does not, someone else added to the cart —
   and we do what Dawn would have done: re-render the drawer and
   the count bubble from the Section Rendering API, then open the
   drawer.

   Both transports are patched because the app uses XHR today and
   could switch to fetch in any release.

   Everything is wrapped so that a failure here can never break
   add-to-cart itself. The worst case is the old silent behaviour.

   NOTE: this does not fix the app's other bug — its multi-variant
   "Add" buttons (class `openbox`) point at a lightbox id that is
   never rendered, so they fire no request at all and there is
   nothing here to react to. That one needs a vendor fix.
   ============================================================ */
(function () {
  'use strict';

  if (window.__pcCartFeedbackInstalled) return;
  window.__pcCartFeedbackInstalled = true;

  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
  var origFetch = window.fetch;
  var busy = false;

  /* Dawn asks for the drawer sections in its own add request and
     renders them from the response. A payload without them came
     from somebody else. `status` marks Shopify's error payloads. */
  function isForeignAdd(json) {
    return !!json && !json.sections && !json.status;
  }

  function refreshAndOpen() {
    if (busy) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    busy = true;

    var ids;
    try {
      ids = drawer.getSectionsToRender().map(function (s) { return s.id; });
    } catch (e) {
      ids = ['cart-drawer', 'cart-icon-bubble'];
    }

    origFetch(window.location.pathname + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        /* renderContents repaints both sections and opens the
           drawer on a timeout, exactly as it does for Dawn's own
           adds — so the upsell rail ends up behaving identically
           to every other Add button on the site. */
        drawer.renderContents({ sections: sections });
      })
      .catch(function () { /* silence beats a broken page */ })
      .then(function () { busy = false; });
  }

  /* ---- fetch ---- */
  if (typeof origFetch === 'function') {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var promise = origFetch.apply(this, arguments);
      if (!ADD_RE.test(url)) return promise;

      return promise.then(function (response) {
        try {
          response.clone().json().then(function (json) {
            if (isForeignAdd(json)) setTimeout(refreshAndOpen, 300);
          }).catch(function () {});
        } catch (e) {}
        return response;
      });
    };
  }

  /* ---- XMLHttpRequest ---- */
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try { this.__pcIsCartAdd = ADD_RE.test(String(url)); } catch (e) {}
    return origOpen.apply(this, arguments);
  };

  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr.__pcIsCartAdd) {
      xhr.addEventListener('load', function () {
        if (xhr.status < 200 || xhr.status >= 300) return;
        var json = null;
        try { json = JSON.parse(xhr.responseText); } catch (e) { return; }
        if (isForeignAdd(json)) setTimeout(refreshAndOpen, 300);
      });
    }
    return origSend.apply(this, arguments);
  };
})();